import React, {Component} from "react";
import {reduxForm} from "redux-form/immutable";
import ActionButton from "../../components/ActionButton";
import FormError from "../../components/forms/FormError";
import AddressWithSelection from "../../components/AddressWithSelection";
import AddressList from "../views/AddressList";
import "./ChangeShippingAddressForm.css";

class ChangeShippingAddressForm extends Component {

  constructor(props) {
    super(props);
    this.handleAddressListChange = this.handleAddressListChange.bind(this);
  }

  render() {
    let {errors, handleSubmit, submitting} = this.props;
    let submitLabel = submitting ? "Standby..." : "Submit"; 

    return (
      <form className="ChangeShippingAddressForm" onSubmit={handleSubmit}>
        <div className="fields">
          <p>Selected address</p>
          <AddressWithSelection 
            id="current" 
            selected={this.props.selectedId === "current"}
            address={this.props.selectedAddress} 
            onSelect={this.handleSelect.bind(this)} 
            />
          {this.renderUsedShippingAddresses()}          
        </div>
        <FormError error={errors._error} />
        <div className="buttons">
          <ActionButton onClick={handleSubmit(values => this.props.onSubmit(values))} primary={true} label={submitLabel} active={!submitting} />
          <ActionButton label="Cancel" active={!submitting} onClick={this.props.onCancel} />
          <ActionButton label="New Address" active={!submitting} onClick={this.props.onNewAddress} />
        </div>
      </form>
    )
  }

  renderUsedShippingAddresses() {
    if (this.props.usedShippingAddresses.size > 0) {
      return (
        <React.Fragment>
          <p>Previously used addresses</p>
          <AddressList
            addresses={this.props.usedShippingAddresses}
            selectedId={this.props.selectedId}
            onChange={this.handleAddressListChange}
            />
        </React.Fragment>
      ) 
    } else {
      return null;
    }
  }

  handleSelect(id) {
    this.props.onSelect(id);
  }

  handleAddressListChange(id) {
    this.props.onSelect(id);
  }

}

const ReduxForm = reduxForm({
  form: "ChangeShippingAddressForm"
})(ChangeShippingAddressForm);

export default ReduxForm;